//
//
//
//

export default {
  props: {
    title: {
      required: false,
    },
    description: {
      required: false,
    },
    backgroundClass: {
      type: String,
      required: true,
    },
  },
};
